<template>
    <el-dialog
        class="shopify-listing-detail"
        :visible.sync="detailVisible"
        :close-on-click-modal="false"
        @closed="closeDialog"
        width="1400px"
        :title="$t('listingRecord.tableName.dialogTitle')"
        :lock-scroll="false"
        :modal-append-to-body="false"
        append-to-body
    >
        <search-tool
            ref="searchTool"
            :status="status"
            :statusList="statusList"
            :funcName="funcName"
            :searchForm="searchForm"
            :searchList="searchList"
            :searchForm_transfer="searchForm_transfer"
            :advanceSearchFields="advanceSearchFields"
            listName="shopifyList"
            :loading="loading"
        ></search-tool>

        <div
            :class="`table${
                (hasSearchCondition && ' has-search-condition') || ''
            }`"
        >
            <el-table
                :data="tableData"
                ref="tableData"
                row-key="id"
                @selection-change="handleSelectionChange"
                :row-class-name="tableRowClassName"
            >
                <el-table-column type="selection" align="center">
                </el-table-column>
                
                <el-table-column
                    align="left"
                    :label="$t('listingRecord.tableName.shopName')"
                    prop="shop_name"
                    show-overflow-tooltip
                >
                </el-table-column>

                <el-table-column
                    align="left"
                    :label="$t('listingRecord.tableName.sku')"
                    prop="sku"
                >
                </el-table-column>
                <el-table-column
                    align="left"
                    :label="$t('listingRecord.tableName.status')"
                    prop="status_sn"
                >
                </el-table-column>
                <el-table-column
                    align="left"
                    :label="$t('listingRecord.tableName.error')"
                    prop="error"
                >
                </el-table-column>
                <el-table-column
                    align="left"
                    :label="$t('listingRecord.tableName.createTime')"
                    prop="created_at"
                >
                </el-table-column>

                <el-empty :image-size="120" slot="empty">
                    <img slot="image" src="@/assets/image/empty-data.svg">
                </el-empty>
            </el-table>
        </div>
        <pagination
            :paginationData="paginationData"
            @paginationChange="paginationChange"
            :funcName="funcName"
        ></pagination>
    </el-dialog>
</template>
<script>
import { cmofferApi } from "@/http/cmofferApi.js";
import { infoTagsMixins } from "@/utils/infoTagsMixins.js";
import { tableMixins } from "@/utils/tableMixins.js";

export default {
    mixins: [infoTagsMixins, tableMixins],
    data() {
        return {
            searchForm: {
                sku: "",
            },
            searchForm_transfer: {
                published_time: "",
            },
            funcName: "listingRecord",
            //addVisible: false,
            //editVisible: false,
            detailVisible: false,
        };
    },
    methods: {
        /**
         * 获取table
         */
        listingRecord(page) {
            console.log(this.tableItem)
            this.loading = true;
            cmofferApi
                .listingRecordDetail(
                    {
                        ...this.paginationData,
                        ...this.searchForm,
                        batch_no: this.tableItem.batch_no,
                        status:this.status,
                    },
                    "get"
                )
                .then((res) => {
                    if (res) {
                        this.tableData = res.data;
                        this.paginationData.total = res.total;
                        this.closeDrawer();
                        this.loading = false;
                    }
                })
                .catch(() => {
                    this.loading = false;
                });
        },
        closeDialog() {
            this.$emit("update:detailVisible", false);
        },
    },
    components: {
    },
    props: {
        detailVisible: Boolean,
        tableItem: Object,
        platform_id: Number,
        status:String,
    },
    computed: {
    },
    watch: {
        detailVisible(val) {
            if (val) {
                this.loading = true;
                const { query } = this.$route
                this.searchForm.keyword = ''
                this.searchForm.status = query.status
                this.listingRecord();
            }
        },
        searchForm: {
            handler(newValue) {
                for (let k in newValue) {
                    let v = newValue[k];
                    if (!!v) {
                        this.hasSearchCondition = true;
                        return;
                    }
                }

                this.hasSearchCondition = false;
            },
            deep: true,
            immediate: true,
        },
    },
};
</script>
<style lang="scss">
.shopifyList {
    width: 100%;
    height: 100%;
    background: #fff;
    .table {
        margin: 0 15px !important;
        padding: 0 !important;
        width: auto !important;

        height: calc(100% - 160px);
        .goods-name {
            width: 75%;
            color: $color-333333;
            margin-bottom: 10px;
        }
        .table-selectedRow-bgcolor {
            &:hover td, td {
                background-color: #f0f9eb !important;
            }
        }
        .el-scrollbar__wrap {
            overflow-x: hidden;
        }

        &.has-search-condition {
            height: calc(100% - 192px);
        }
    }
}
</style>
